import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpClientBase } from "./http-client-base.service";


@Injectable({
    providedIn: 'root'
})
export class DetalleFinalizadosService extends HttpClientBase {

    constructor(http: HttpClient){
        super(http , 'lotes');
    }

    getDetalleFinalizados(loteId:number) {
        return this.get<any[]>({endpoint: `${loteId}/detalles/finalizados`})
    }
}